import strings from '../../Localization/Localization';

import { store } from '../../Store/configureStore';

import {
  users as usersRoutes,
  quotes as quotesRoutes,
  orders as ordersRoutes
} from '../Route/routes';

export let bonusType = {
  fieldKey: "bonus_type",
  label: strings.form.commercialBonus.bonusType.label,
  type: "dropdown",
  validators: [],

  showEmpty: true,
  input: 'options',
  options: [
    {
      value: 0,
      label: strings.form.commercialBonus.bonusType.options.quotePunctual
    },
    {
      value: 1,
      label: strings.form.commercialBonus.bonusType.options.orderPunctual
    }
  ],
}

let base = {
  fieldKey: "base",
  type: "price",
  label: strings.form.commercialBonus.base.label,
  validators: []
}

let percentage = {
  fieldKey: "percentage",
  type: "text",
  label: strings.form.commercialBonus.percentage.label,
  validators: []
}

let amount = {
  fieldKey: "bonus_amount",
  type: "price",
  label: strings.form.commercialBonus.amount.label,
  validators: []
}

let user = {
  fieldKey: "user",
  label: strings.form.commercialBonus.user.label,
  type: "dropdownEntity",
  disabled: () => true,

  disabledLink: (value, getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      if(value && !Array.isArray(value) && credentials.roles.includes('ROLE_NYUKOM') && (credentials.roles.includes('ROLE_USER_ADMIN') || credentials.roles.includes('ROLE_USER_INDEX'))) {
        return usersRoutes.routes.show.createPath(value["id"]);
      }
    }
    return false;
  },

  validators: [],

  showEmpty: true,
  loader: null,

  adapter: {
    requirement: (data) => data["id"] && data["displayname"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["displayname"],
  },
}

let origins = {
  fieldKey: "origins",
  label: "",
  type: "array",
  disabled: () => true,

  validators: [],

  subField: {
    type: "configurableField",
    label: "",

    validators: [],

    subFieldConf: {
      label: (value, getValues) => {
        switch (getValues()["bonus_type"]) {
          case 0:
            return strings.form.commercialBonus.origin.label.quote
          case 1:
            return strings.form.commercialBonus.origin.label.order
          default:
            return "ERROR"
        }

      },
      type: () => "dropdownEntity",
      disabled: () => false,
      validators: () => []
    },

    subField: () => {
      return {
        disabledLink: (value, getValues, getExtraValues) => {
          let values = getValues();
          let extraValues = getExtraValues();
          if(extraValues.credentials) {
            let credentials = extraValues.credentials();
            if(value && !Array.isArray(value)) {
              if(values["bonus_type"] === 0 && credentials.roles.includes('ROLE_QUOTE')) {
                return quotesRoutes.routes.show.createPath(value["id"]);
              }
              else if(values["bonus_type"] === 1 && credentials.roles.includes('ROLE_ORDER')) {
                return ordersRoutes.routes.show.createPath(value["id"]);
              }
            }
          }
          return false;
        },

        showEmpty: true,
        loader: null,

        adapter: {
          requirement: (data) => data["id"] && data["number"],
          getValue: (data) => data["id"],
          getLabel: (data) => data["number"],
        },
      }
    },
  }
}

let details = {
  fieldKey: "details",
  type: "table",
  label: strings.form.commercialBonus.details.label,
  validators: [],

  table: {
    headers: [
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "string",
        value: (item, line, context) => {
          if(context.values["bonus_type"] === 0) {
            return "Devis";
          }
          return item.origin.product.name
        },
        label: strings.form.commercialBonus.details.header.origin,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "price",
        value: "selling_price",
        label: strings.form.commercialBonus.details.header.sellingPrice,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "price",
        value: "calculation_base",
        label: strings.form.commercialBonus.details.header.calculationBase,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "float",
        value: item => item["percentage_bonus_value"]/100,
        label: strings.form.commercialBonus.details.header.percentage,
        editable: false,
        additionalConfiguration: {
          numberStyle: {
            style: "percent"
          }
        }
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "price",
        value: "bonus_amount",
        label: strings.form.commercialBonus.details.header.bonusAmount,
        editable: false
      },
      {
        headerColSpan: 1,
        itemColSpan: 1,
        type: "switch",
        value: "validated",
        label: strings.form.commercialBonus.details.header.validated,
        editable: true
      }
    ]
  }
}

let comment = {
  fieldKey: "comment",
  type: "textarea",
  label: strings.form.commercialBonus.comment.label,
  validators: []
}

let receivedAt = {
  fieldKey: "received_at",
  type: "date",
  label: strings.form.commercialBonus.receivedAt.label,
  validators: []
}

let receivedAtPrevision = {
  fieldKey: "received_at_prevision",
  type: "date",
  label: strings.form.commercialBonus.receivedAtPrevision.label,
  validators: []
}

let validated = {
  fieldKey: "validated",
  type: "triswitch",
  label: strings.form.commercialBonus.validated.label,
  validators: []
}

export const validationForm = {
  formKey: "commercialBonus",
  fields: [
    details,
    comment,
    validated,
    receivedAtPrevision,
    receivedAt
  ],
  extraValues: {
    credentials: () => store.getState().persisted.credentials
  }
}

export const form = {
  formKey: "commercialBonus",
  fields: [
    bonusType,
    validated,
    origins,
    base,
    percentage,
    amount,
    user,
  ],
  extraValues: {
    credentials: () => store.getState().persisted.credentials
  }
}
